import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TipLinkModule } from '../../tip-link/tip-link.module';
import { TrNumberComponent } from './tr-number.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TipLinkModule,
    ],
    exports: [ TrNumberComponent ],
    declarations: [ TrNumberComponent ],
})
export class TrNumberModule {}
